import { Component, Input } from '@angular/core';
import { NgIf } from "@angular/common";
import { NzEmptyComponent } from "ng-zorro-antd/empty";

@Component({
  selector: 'app-no-data',
  standalone: true,
  imports: [
    NgIf,
    NzEmptyComponent
  ],
  templateUrl: './no-data.component.html',
  styleUrl: './no-data.component.scss',
})
export class NoDataComponent {
  @Input() msg: string = "No Data Available";
  @Input() showImage: boolean = true;
  // @Input() path: string = 'assets/images/no-data-new.svg'
  @Input() path: string = 'default'
}
